import React from 'react'
import './LoadinSkeletonArmaTuPc.css'

function LoadinSkeletonArmaTuPc() {
  return (
    <div className={"item_container_loading"}>
    <div className="flex_left_item_container">
      <h4></h4>
      <h5></h5>
    </div>
    <div className="flex_right_item_container">
      
    </div>
  </div>
  )
}

export default LoadinSkeletonArmaTuPc